export default "__VITE_ASSET__vbGpHn6k__"